export default __webpack_public_path__ + "static/media/flashcards-screen.8e39ec1a.png";